import { Component, OnInit } from '@angular/core';
import {DoodleModel} from "../../doodle-model";
import {DoodlesService} from "../../doodles.service";

@Component({
  selector: 'app-lithuania-day',
  templateUrl: './lithuania-day.component.html',
  styleUrls: ['./lithuania-day.component.less']
})
export class LithuaniaDayComponent implements OnInit {
  public model: DoodleModel;

  constructor(
    private doodlesService: DoodlesService
  ) { }

  ngOnInit(): void {

    this.model = this.doodlesService.doodleModel;
  }

}
